
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("20DN7", function(module, exports) {
$parcel$export(module.exports, "subscribeCrossDomainCommunication", () => (parcelRequire("RirqF")).subscribeCrossDomainCommunication);

var $RirqF = parcelRequire("RirqF");


});

parcelRegister("RirqF", function(module, exports) {

var $3XKuW = parcelRequire("3XKuW");

var $eFNS0 = parcelRequire("eFNS0");


var $diaaX = parcelRequire("diaaX");


var $fzXaO = parcelRequire("fzXaO");

let $495080abf9363288$var$AP = null;


// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    // unable to evaluate fg('platform_deprecate_lp_cc_embed') at the module level and using uniqueKey query param (which is feature gated) instead
    let hasUniqueKey = false;
    if (typeof window !== 'undefined') try {
        hasUniqueKey = new URL(window.location.href).searchParams.has('uniqueKey');
    } catch (e) {
        hasUniqueKey = false;
    }
    $495080abf9363288$var$AP = hasUniqueKey ? (parcelRequire("cjK8y")) : (parcelRequire("hyxhF"));
}
const $495080abf9363288$export$a8b909b2766dc5fa = ()=>{
    if (!$495080abf9363288$var$AP) return;
    let uniqueKey = null;
    try {
        uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
    } catch (e) {
        uniqueKey = null;
    }
    const module = (0, $fzXaO.requireModule)(uniqueKey ? `${0, $diaaX.PASSTHROUGH_PROPS_MODULE_NAME}_${uniqueKey}` : (0, $diaaX.PASSTHROUGH_PROPS_MODULE_NAME));
    if (!module) return;
    const observableObject = new (0, $eFNS0.ObservableObject)();
    // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
    window[0, $3XKuW.EP_REACT_PROPS_OBSERVABLE_OBJECT] = observableObject;
    let props;
    $495080abf9363288$var$AP.register({
        // Subcribe to "propsUpdated" event from parent window
        // Once received and parsed data, set the object as value for Observable
        // Subsequent "propsUpdated" event will trigger subscribers set up by `useReactProps`
        [(0, $diaaX.PROPS_UPDATED)]: ({ message: message })=>{
            try {
                props = JSON.parse(message);
            } catch (e) {
                props = undefined;
            }
            if (props) observableObject.object = {
                ...props,
                navigationPolicy: {
                    ...props?.navigationPolicy,
                    // Delegate the handling of navigationPolicy.navigate to defined module method in parent window
                    navigate: module.navigationPolicyNavigate
                },
                onPublish: module.onPublish
            };
        }
    });
    //Trigger the command to get passthrough props from parent window
    module.getProps();
};
module.exports["subscribeCrossDomainCommunication"] = $495080abf9363288$export$a8b909b2766dc5fa;

});


//# sourceMappingURL=subscribeCrossDomainCommunication.c89c8018.js.map
